import {
  Cascader,
  type CascaderProps,
  DatePicker,
  Select,
  type SelectProps,
  Space,
} from 'antd';
import moment from 'moment';
import React, { type FC } from 'react';

import type { FeedbackSearchQuery } from '../FeedbackList/types';

const FeedbackFilter: FC<{
  householdNumberOptions: CascaderProps['options'];
  typeOptions: SelectProps['options'];
  query: FeedbackSearchQuery;
  setQuery: React.Dispatch<React.SetStateAction<FeedbackSearchQuery>>;
}> = ({ householdNumberOptions, typeOptions, query, setQuery }) => {
  return (
    <Space direction="horizontal">
      <Cascader
        options={householdNumberOptions}
        onChange={(val) => {
          const householdNumber = val?.join('-') || undefined;
          setQuery((prev) => ({ ...prev, householdNumber, page: 1 }));
        }}
        placeholder="請選擇戶號"
        allowClear
      />
      <Select
        options={typeOptions}
        onChange={(val) => {
          setQuery((prev) => ({ ...prev, type: val, page: 1 }));
        }}
        placeholder="請選擇類別"
        allowClear
      />
      <DatePicker.RangePicker
        value={query.queryTimes}
        onChange={(val) => {
          const queryTimes: typeof query['queryTimes'] = val
            ? [moment(val[0]), moment(val[1])]
            : undefined;
          setQuery((prev) => ({ ...prev, queryTimes, page: 1 }));
        }}
      />
    </Space>
  );
};

export default FeedbackFilter;
